export function cssVar<T extends string>(varName: T): `var(${T})`
export function cssVar<T extends string, U extends string>(
  varName: T,
  fallback: U
): `var(${T}, ${U})`
export function cssVar(varName: string, fallback?: string): string {
  return fallback === undefined
    ? `var(${varName})`
    : `var(${varName}, ${fallback})`
}
